module.exports = "/_next/static/images/horse_batman_tokens-577d6d98858592b20beab8eec3457c36.png";